// extracted by mini-css-extract-plugin
export default {"container":"Bob_container__4Oceo","mimo":"Bob_mimo__MzUX3","textBox":"Bob_textBox__UjE+B","textList":"Bob_textList__Yd9Yz"};